<template>
  <div class="base-form-div">
    <div>
      <el-form
        :label-position="labelPosition"
        ref="form"
        :model="{}"
        label-width="80px"
        size="mini"
      >
        <el-form-item label="名称">
          <el-input v-model="name"></el-input>
        </el-form-item>
        <el-form-item v-for="(item, index) in attrForm" :label="item.name">
          <el-color-picker
            @change="changeColor"
            :predefine="predefineColors"
            show-alpha
            :color-format="'hex'"
            v-model="item.color"
          >
          </el-color-picker>
        </el-form-item>
        <!-- <el-form-item label="线宽">
                    <el-input-number v-model="attrForm.width" controls-position="right" :min="1"></el-input-number>
                </el-form-item>
                <el-form-item label="文本">
                    <el-input v-model="attrForm.text" controls-position="right"></el-input>
                </el-form-item> -->
        <el-form-item label="显示层级">
          <el-input-number
            @change="formSetChange"
            v-model="formSet.zIndex"
            controls-position="right"
          ></el-input-number>
        </el-form-item>
      </el-form>
    </div>
    <div v-html="svgElement" id="drawing" class="svg-board"></div>
    <div class="form-bottom">
      <!-- <el-button class="base-button" size="mini" type="primary" @click="confirmPlot">确定</el-button> -->
      <el-button class="base-button" size="mini" type="primary" @click="savePlot"
        >保存</el-button
      >
      <!-- <el-button class="base-button" size="mini" type="primary" @click="exportPlot">导出</el-button> -->
      <el-button class="base-button" size="mini" type="primary" @click="deletePlot"
        >删除</el-button
      >
    </div>
  </div>
</template>

<script>
//--常規
//--文本
//--衬线
//--辅件
//--信息
//--尾线
import axios from "axios";
import { SVG } from "@svgdotjs/svg.js";
import { svg2CanvasExt, svgToblobJB, svgToUrl } from "./lib/image.js";
import { getCommonAjax } from "@/api/common.js";
import { createMark, deleteByMarkId } from "@/api/vectorPlot/index.js";
import StyleUtil from "@/utils/cesiumBD/utils/StyleUtil.js";
import * as Help from "@/components/PlanEditor/Actions/help.js";
let entity;
export default {
  props: ["subData"],
  data() {
    return {
      predefineColors: ["#ff0000", "#0000ff", "#00ff00", "#00ffff"],
      labelPosition: "left",
      attrForm: [],
      svgElement: "",
      timer: undefined,
      SVGObj: undefined,
      changeColorArr: ["path", "polygon"],
      name: "",
      formSet: {
        materialType: "ImageMaterialProperty",
        materialOption: {
          color: "rgba(255, 255, 255, 1)",
          image: "",
        },
        zIndex: 0,
      },
    };
  },
  // watch: {
  //     formSet: {
  //         // 数据变化时执行的逻辑代码
  //         handler(newObj, oldObj) {
  //             if (this.isCalculate) {
  //                 StyleUtil.setStyle2Entity(newObj, entity, "rectangle")
  //             }
  //         },
  //         // 开启深度监听
  //         deep: true,
  //         immediate: false
  //     }

  // },
  async created() {
    entity = this.subData();
    this.name = entity.markName || "军标";
    this.formSet.materialOption.image = entity.rectangle.material.image.getValue();
    var res = await axios.get(this.formSet.materialOption.image);
    this.svgElement = res.data;
  },
  mounted() {
    this.$nextTick(() => {
      let node = null;
      this.timer = setInterval(() => {
        node = document.getElementById("drawing"); //获取元素
        if (node && node.firstChild) {
          clearInterval(this.timer);
          this.initSVGObj(node);
          this.initAttrs();
        }
      }, 1);
    });
  },
  methods: {
    formSetChange() {
      StyleUtil.setStyle2Entity(this.formSet, entity, "rectangle");
    },
    initSVGObj(node) {
      if (this.SVGObj) {
        return this.SVGObj;
      }
      this.SVGObj = SVG(node);
      return this.SVGObj;
    },
    initAttrs() {
      //初始化属性
      //var styleAttr = entity.styleAttr;
      if (entity.rectangle && entity.rectangle.attr && entity.rectangle.attr.attrForm) {
        this.attrForm = entity.rectangle.attr.attrForm;
        //this.changeColor();
        return;
      }

      // if (styleAttr && styleAttr.attrForm) {
      //     var attrForm = styleAttr.attrForm;
      //     this.attrForm = attrForm;
      //     this.changeColor();
      //     return;
      // }
      this.attrForm = this.getSelfAttrForm();
    },

    getSelfAttrForm() {
      var pathArr = this.SVGObj.find("path");
      var attrForm = pathArr.map((path, index) => {
        var fillColor = path.attr("fill");
        return {
          color: fillColor,
          name: "部件" + Number(index + 1) + "颜色",
        };
      });

      if (pathArr.length === 1) {
        attrForm[0].name = "填充颜色";
      }
      return attrForm;
    },
    saveAttr() {
      let element = document.getElementById("drawing"); //获取元素
      let svgdom = element.firstChild;
      var url = svgToUrl(svgdom);
      entity.rectangle.material = url;

      entity.rectangle.attr = entity.rectangle.attr || {};
      var styleAttr = entity.rectangle.attr;
      styleAttr.attrForm = this.attrForm;
    },
    changeText() {
      var textArr = this.SVGObj.find("text");
      textArr.tspan(this.attrForm.text);
    },
    changeColor() {
      var pathArr = this.SVGObj.find("path");
      this.attrForm.forEach((item, index) => {
        pathArr[index].attr("fill", item.color);
        // pathArr[index].attr("fill", "none");
        // pathArr[index].attr("stroke-dasharray", "5,5");
      });
      this.saveAttr();
    },
    changeWidth() {
      var pathArr = this.SVGObj.find("path");
      pathArr.css("stroke-width", this.attrForm.width);
    },
    setStyle(style, att, value) {
      var atts = style.split(";");
      var orig = undefined;
      for (var i = 0; i < atts.length; i++) {
        var arrPro = atts[i].split(":");
        if (arrPro[0] == att) {
          orig = arrPro[1];
          break;
        }
      }
      var before = att + ":" + orig;
      var after = att + ":" + value;
      const regExp = new RegExp(`${before}`, "ig");
      const str = style.replace(regExp, after);
      return str;
    },
    savePlot() {
      let element = document.getElementById("drawing"); //获取元素
      let svgdom = element.firstChild;
      var url = svgToblobJB(svgdom);
      this.formSet.materialOption.image = url;
      this.formSet.attrForm = this.attrForm;

      var rotation;
      var stRotation;
      var postureAttr = {};
      if (entity.rectangle.rotation) {
        rotation = entity.rectangle.rotation.getValue();
      }
      if (entity.rectangle.stRotation) {
        stRotation = entity.rectangle.stRotation.getValue();
      }
      if (rotation && stRotation) {
        postureAttr = { rotation: rotation, stRotation: stRotation };
      }

      let data = {
        extType: "军标",
        editPositions: JSON.stringify(entity.attrPlot.edit_positions),
        styleAttr: JSON.stringify(this.formSet),
        postureAttr: JSON.stringify(postureAttr),
        userId: 111,
        markId: entity.id,
        markName: this.name,
      };

      console.log(data);

      let action = {};
      action.name = this.name;
      action.type = "militaryPlot";
      action.typeName = "军事标绘";
      action.delay = 1;
      action.data = data;
      // if (entity.isPlotflag) {
      //   this.$bus.$emit("addActionObj", action);
      //   Help.addEntityArr(entity);
      //   this.$parent.close();
      //   return;
      // }

      if (entity.isAlreadyPlotflag) {
        entity.markName = this.name;
        entity.update(action);
        this.$parent.close();
        return;
      }
      if (typeof this.subData != "function") {
        this.subData.update(action);
        this.$parent.close();
        return;
      }
      if (entity.isPlotflag) {
        entity.isPlotflag = false;
        entity.markName = this.name;
        this.$bus.$emit("addActionObj", action);
        Help.addEntityArr(entity);
        this.$parent.close();
        return;
      }

      createMark(data)
        .then((res) => {
          this.$message({
            showClose: true,
            message: "保存成功,请到我的标绘中进行查看！",
            type: "success",
            duration: 3 * 1000,
          });
          this.$bus.$emit("vectorPlot-list");

          entity.markName = data.markName;
        })
        .catch((err) => {
          console.err(err);
        });
    },
    deletePlot() {
      if (entity.isPlotflag) {
        StyleUtil.deletePlot(entity);
        this.$parent.close();
        return;
      }
      this.$confirm("是否删除该条数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteByMarkId(entity.id).then((res) => {
            console.log(res);
            this.$message({
              showClose: true,
              message: "删除成功！",
              type: "success",
              duration: 3 * 1000,
            });
            this.$bus.$emit("vectorPlot-list");
            StyleUtil.deletePlot(entity);
            this.$parent.close();
          });
        })
        .catch(() => {
          this.$message({
            showClose: true,
            type: "info",
            message: "本次操作已取消！",
            duration: 3 * 1000,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.base-form-div {
  padding: 20px;
}

.svg-board {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e4e7ed;
  margin-top: 20px;
  padding: 20px 0;
  height: 160px;

  > svg {
    height: 100% !important;
  }
}

.form-bottom {
  text-align: center;
  // border-top: 1px solid rgba(153, 153, 153, 0.50);
  padding-top: 20px;
}
</style>
<style lang="scss">
.svg-board {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e4e7ed;
  margin-top: 20px;
  padding: 20px 0;
  height: 160px;

  > svg {
    height: 100% !important;
  }
}
</style>
